// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1PKLH","socialLinks":"Footer_socialLinks__eexBp","icon":"Footer_icon__2wmVs"};